export default __webpack_public_path__ + "static/media/stephanie_tommy-206.f5792c3c.jpg";